module.exports = __webpack_public_path__ + "img/thore_videobotschaft_b2c.195bdc88.jpg";